export const buildSharePageUrl = (
  configs: Map<string, string>,
  path: string
): string => {
  const domain = (configs.get('sharePageDomain') ?? '').replace(/\/+$/, '');
  const segment = path.replace(/^\/+/, '');
  if (!domain) {
    return segment ? `/${segment}` : '/';
  }
  return `${domain}/${segment}`;
};
